import { useMemo } from 'react';
import { CameraProps } from '../types';

interface UseGetCameraConstraintsOptions {
  cameraFacing: CameraProps['cameraFacing'];
}

function useGetCameraConstraints({
  cameraFacing,
}: UseGetCameraConstraintsOptions) {
  return useMemo<MediaTrackConstraints>(() => {
    let facingMode: string | ConstrainDOMStringParameters = 'user';

    if (cameraFacing === 'back') {
      facingMode = navigator.userAgent.includes('Android' || 'iPhone')
        ? { exact: 'environment' }
        : 'user';
    }

    return {
      width: 1400,
      height: 976,
      facingMode,
    };
  }, [cameraFacing]);
}

export default useGetCameraConstraints;
